class PromoformAddProductButton extends Component {
    /** {HTMLFormElement} */
    _form;

    constructor(el) {
        super(el);

        this._form = el.closest("form");
        this.maxProductCount = parseInt(this.$el.dataset.maxProductCount);
        this.productGroups = document.querySelectorAll('[data-component=PromoformProduct]');
        this.currentProductCount = this.getInitialProductCount();
        this.button = this.$el.querySelector('button');
        this.button.addEventListener('click', () => {
            this.addProduct();
            this.refreshProductVisibility();
        });
        this.refreshProductVisibility();
    }

    getInitialProductCount() {
        const initialProductCount = this._form.dataset.initialProductCount;
        const currenProductCount = this.determineCurrentProductCountFromFormElements();
        if (initialProductCount === undefined || currenProductCount > initialProductCount) {
            return currenProductCount;
        }

        return Number.parseInt(initialProductCount);
    }

    determineCurrentProductCountFromFormElements() {
        let index = 0;
        let currentProductCount = 0;
        for (const productGroup of this.productGroups) {
            index++;
            const modelElement = productGroup.querySelector('[data-component=PromoformProductModel]');
            if (modelElement.value) {
                currentProductCount = index;
            }
        }
        return currentProductCount;
    }

    addProduct() {
        if (this.currentProductCount >= this.maxProductCount) {
            return;
        }
        this.currentProductCount++;
    }

    refreshProductVisibility() {
        for (let i = 0; i < this.maxProductCount; i++) {
            this.productGroups[i].style.display = (i < this.currentProductCount) ? 'grid' : 'none';
        }
        this.button.style.display = (this.currentProductCount === this.maxProductCount) ? 'none' : 'inline-flex';
    }
}

